export const MODAL = {
  REGISTRATION_FORM_HAS_BEEN_SENT: {
    title: "Заявка на регистрацию отправлена",
    description: "После одобрения заявки мы пришлём уведомление на ваш E-mail.",
  },
  PASSWORD_RECOVERY_FORM: {
    title: "Восстановление пароля",
    description:
      "Введите адрес электронной почты, который вы использовали для входа. Мы отправим на него ссылку для смены пароля.",
  },
};
